export default "__VITE_ASSET__D4Hv2vqT__"